import PropTypes from 'prop-types'
import { Text } from '@qonsoll/react-design'
import { useGetStores } from 'domains/Store/hooks'
import { useSubfilterActions } from 'hooks'
import { useTranslations } from 'contexts/Translation'
import { Checkbox } from 'antd'

const StoreFilter = ({ filterData, setFilterData }) => {
  const [stores] = useGetStores()
  const { t } = useTranslations()

  const { onToggleDetails, onChange, checkIsEnabled } = useSubfilterActions({
    filterData,
    setFilterData,
    fieldName: 'storeId',
    operand: '==',
    type: 'store'
  })

  return (
    <details
      open={localStorage.getItem(`store-details-visibility`) === 'opened'}>
      <summary onClick={onToggleDetails}>{t('Store')}</summary>
      {stores?.map((editor, index) => (
        <Checkbox
          key={`status-${index}`}
          checked={checkIsEnabled(editor)}
          onChange={() => onChange(editor)}>
          <Text wordBreak="break-all">
            {editor?.name || t('Unnamed filter')}
          </Text>
        </Checkbox>
      ))}
    </details>
  )
}

StoreFilter.propTypes = {
  filterData: PropTypes.object,
  setFilterData: PropTypes.func
}

export default StoreFilter
